import React from 'react';

// Stable color per location name
function locationColor(name) {
  if (!name) return '#f7dc6f';
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  const hue = ((hash % 360) + 360) % 360;
  return `hsl(${hue}, 55%, 75%)`;
}

function locationColorDark(name) {
  if (!name) return '#7d6608';
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  const hue = ((hash % 360) + 360) % 360;
  return `hsl(${hue}, 60%, 30%)`;
}

function CustomDateHeader({ date, label, dayNameMap = {}, onAddDayLabel, onRemoveLabel }) {
  const day = date.getDate();
  const dateKey = date.toLocaleDateString('sv-SE');
  const entries = dayNameMap[dateKey]; // array or undefined

  const isLabeled = Array.isArray(entries) && entries.length > 0;

  const handleClick = (e) => {
    e.stopPropagation();
    if (isLabeled) {
      onRemoveLabel(dateKey, entries[0]?.scheduleId);
    } else {
      onAddDayLabel(dateKey);
    }
  };

  return (
    <div style={{
      position: 'relative',
      backgroundColor: isLabeled && entries.length === 1 ? locationColor(entries[0].locationName) : '#FFFFFF',
      fontSize: '14px',
      textAlign: 'center',
      width: '105%',
      margin: '0px',
      paddingRight: '20px',
    }}>
      {isLabeled ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}>
          {entries.map((entry, i) => (
            <div
              key={entry.scheduleId || i}
              style={{
                backgroundColor: locationColor(entry.locationName),
                color: locationColorDark(entry.locationName),
                padding: '1px 4px',
                fontSize: '11px',
                fontWeight: 600,
                lineHeight: '15px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                borderBottom: i < entries.length - 1 ? `1px solid ${locationColorDark(entry.locationName)}30` : 'none',
              }}
              title={`${entry.name} — ${entry.locationName || 'No location'}`}
            >
              {entry.name}
            </div>
          ))}
          <div style={{ fontSize: '12px', fontWeight: 600, lineHeight: '16px' }}>{day}</div>
        </div>
      ) : (
        <span>{day}</span>
      )}
      <button
        onClick={handleClick}
        title={isLabeled ? 'Delete event' : 'Add event'}
        style={{
          position: 'absolute',
          right: 15,
          top: 0,
          background: isLabeled ? 'red' : 'green',
          color: isLabeled ? 'yellow' : 'white',
          border: 'none',
          borderRadius: '50%',
          width: '16px',
          height: '16px',
          fontSize: '12px',
          cursor: 'pointer',
          lineHeight: '16px',
          padding: 0
        }}
      >{isLabeled ? '\u00d7' : '+'}</button>
    </div>
  );
}

export default CustomDateHeader;
